import { render, staticRenderFns } from "./ReScheduleDelivery.vue?vue&type=template&id=532e31e7&scoped=true&"
import script from "./ReScheduleDelivery.vue?vue&type=script&lang=js&"
export * from "./ReScheduleDelivery.vue?vue&type=script&lang=js&"
import style0 from "./ReScheduleDelivery.vue?vue&type=style&index=0&id=532e31e7&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532e31e7",
  null
  
)

export default component.exports